import { useEffect, useState } from 'react';
import { Tooltip, TooltipTrigger, Text, TooltipContent, VStack } from 'ui_2';

export const ImagePreview = ({
  url,
  label,
}: {
  url: string;
  label: string;
}) => {
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!url) {
      setIsValid(false);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const img = new Image();
    img.onload = () => {
      setIsValid(true);
      setIsLoading(false);
    };
    img.onerror = () => {
      setIsValid(false);
      setIsLoading(false);
    };
    img.src = url;
  }, [url]);

  if (!url) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className='h-6 w-6 flex-shrink-0 cursor-pointer rounded border border-gray-200 transition-colors hover:border-gray-300'>
          {isLoading ? (
            <div className='h-full w-full animate-pulse rounded bg-gray-100' />
          ) : isValid ? (
            <img
              src={url}
              alt={label}
              className='h-full w-full rounded object-cover'
              onError={() => setIsValid(false)}
            />
          ) : (
            <div className='flex h-full w-full items-center justify-center rounded bg-red-50'>
              <Text font='xs' className='text-red-500'>
                !
              </Text>
            </div>
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent
        side='top'
        className='border border-gray-200 bg-white p-2 shadow-lg'
      >
        <VStack className='gap-2'>
          <Text font='xs' color='gray-600'>
            {label}
          </Text>
          <img
            src={url}
            alt={label}
            className='h-52 w-auto object-contain'
            onError={() => setIsValid(false)}
          />
        </VStack>
      </TooltipContent>
    </Tooltip>
  );
};
